'use client';

import { useQuery } from '@tanstack/react-query';
import { LogOut } from 'lucide-react';
import Link from 'next/link';

import { DialogClose } from '@/components/ui/dialog';
import { getLoggedInUserQueryOptions } from '@/query/user';
import { isValueEmpty, userToFullName } from '@/utils';

interface SignpostHeaderProps {
  onLogout: () => void;
}

export const SignpostHeader = ({ onLogout }: SignpostHeaderProps) => {
  const userQuery = useQuery(getLoggedInUserQueryOptions);
  const user = userQuery.data;

  return (
    <div className="flex w-full justify-between rounded-md bg-gray-50 px-5 py-3">
      <div className="flex gap-x-2 text-lg italic sm:gap-x-4 sm:text-2xl">
        <span className="font-bold text-blue-600">{isValueEmpty(user) ? 'N/A' : userToFullName(user)}</span>
      </div>
      <DialogClose asChild>
        <Link
          href="/auth/login"
          onClick={onLogout}
          className="group flex items-center gap-2 text-blue-400 hover:text-red"
        >
          <LogOut className="stroke-blue-400 group-hover:stroke-red" />
          <span
            data-testid="cypress-signout-button"
            className="hidden text-sm font-medium sm:block"
          >
            Odhlásit se
          </span>
        </Link>
      </DialogClose>
    </div>
  );
};
